export const itemRefs:{[key:string]:any} = {
    'Iron Ore': {
        image: 'Items/IconDesc_iron_new_256.png'
    },
    'Copper Ore': {
        image: 'Items/IconDesc_copper_new_256.png'
    },
    'Caterium Ore': {
        image: 'Items/IconDesc_CateriumOre_256.png'
    },
    'Aluminum Scrap': {
        image: 'Items/IconDesc_AluminiumScrap_256.png'
    },
    'Iron Ingot': {
        image: 'Items/IconDesc_IronIngot_256.png'
    },
    'Caterium Ingot': {
        image: 'Items/IconDesc_CateriumIngot_256.png'
    },
    'Aluminum Ingot': {
        image: 'Items/IconDesc_AluminiumIngot_256.png'
    },
    'Copper Ingot': {
        image: 'Items/IconDesc_CopperIngot_256.png'
    },
    'Concrete': {
        image: 'Items/IconDesc_Concrete_256.png'
    },
    'Limestone': {
        image: 'Items/Stone_256.png'
    },
    'Iron Rod': {
        image: 'Items/IconDesc_IronRods_256.png'
    },
    'Screw': {
        image: 'Items/IconDesc_IronScrews_256.png'
    },
    'Iron Plate': {
        image: 'Items/IconDesc_IronPlates_256.png'
    },
    'Copper Sheet': {
        image: 'Items/IconDesc_CopperSheet_256.png'
    },
    'Wire': {
        image: 'Items/IconDesc_Wire_256.png'
    },
    'Cable': {
        image: 'Items/IconDesc_Cables_256.png'
    },
    'Steel Beam': {
        image: 'Items/IconDesc_SteelBeam_256.png'
    },
    'Steel Ingot': {
        image: 'Items/IconDesc_SteelIngot_256.png'
    },
    'Steel Pipe': {
        image: 'Items/IconDesc_SteelPipe_256.png'
    },
    'Rotor': {
        image: 'Items/IconDesc_Rotor_256.png'
    },
    'Reinforced Iron Plate': {
        image: 'Items/IconDesc_ReinforcedIronPlates_256.png'
    },
    'Smart Plating': {
        image: 'Items/IconDesc_SpelevatorPart_1_256.png'
    },
    'Modular Frame': {
        image: 'Items/IconDesc_ModularFrame_256.png'
    },
    'Heavy Modular Frame': {
        image: 'Items/IconDesc_ModularFrameHeavy_256.png'
    },
    'Heavy Oil Residue': {
        image: 'Items/IconDesc_LiquidHeavyOilResidue_Pipe_256.png'
    },
    'Polymer Resin': {
        image: 'Items/IconDesc_PolymerResin_256.png'
    },
    'Water': {
        image: 'Items/LiquidWater_Pipe_256.png'
    },
    'Fabric': {
        image: 'Items/IconDesc_Fabric_256.png'
    },
    'Fuel': {
        image: 'Items/IconDesc_LiquidFuel_Pipe_256.png'
    },
    'Packaged Fuel': {
        image: 'Items/IconDesc_Fuel_256.png'
    },
    'Crude Oil': {
        image: 'Items/LiquidOil_Pipe_256.png'
    },
    'Packaged Water': {
        image: 'Items/IconDesc_PackagedWater_256.png'
    },
    'Solid Biofuel': {
        image: 'Items/IconDesc_SolidBiofuel_256.png'
    },
    'Liquid Biofuel': {
        image: 'Items/IconDesc_LiquidBiofuel_Pipe_256.png'
    },
    'Coal': {
        image: 'Items/IconDesc_CoalOre_256.png'
    },
    'Compacted Coal': {
        image: 'Items/IconDesc_CompactedCoal_256.png'
    },
    'Turbofuel': {
        image: 'Items/IconDesc_LiquidTurboFuel_Pipe_256.png'
    },
    'Bauxite': {
        image: 'Items/IconDesc_Bauxite_256.png'
    },
    'Silica': {
        image: 'Items/IconDesc_Silica_256.png'
    },
    'Alumina Solution': {
        image: 'Items/LiquidAlumina_Pipe_256.png'
    },
    'Sulfur': {
        image: 'Items/Sulfur_256.png'
    },
    'Sulfuric Acid': {
        image: 'Items/IconDesc_LiquidSulfuricAcid_Pipe_256.png'
    },
    'Plastic': {
        image: 'Items/IconDesc_Plastic_256.png'
    },
    'Rubber': {
        image: 'Items/IconDesc_Rubber_256.png'
    },
    'Raw Quartz': {
        image: 'Items/IconDesc_QuartzCrystal_256.png'
    },
    'Quartz Crystal': {
        image: 'Items/IconDesc_QuartzResource_256.png'
    },
    'Quickwire': {
        image: 'Items/IconDesc_Quickwire_256.png'
    },
    'Black Powder': {
        image: 'Items/IconDesc_Gunpowder_256.png'
    },
    'Smokeless Powder': {
        image: 'Items/IconDesc_GunpowderMk2_256.png'
    },
    'Encased Industrial Beam': {
        image: 'Items/IconDesc_EncasedSteelBeam_256.png'
    },
    'Uranium': {
        image: 'Items/IconDesc_UraniumOre_256.png'
    },
    'Encased Uranium Cell': {
        image: 'Items/IconDesc_NuclearCell_256.png'
    },
    'Uranium Fuel Rod': {
        image: 'Items/IconDesc_NuclearFuelRod_256.png'
    },
    'Electromagnetic Control Rod': {
        image: 'Items/IconDesc_ElectromagneticControlRod_256.png'
    },
    'Beacon': {
        image: 'Items/IconDesc_Beacon_256.png'
    },
    'Crystal Oscillator': {
        image: 'Items/IconDesc_CrystalOscillator_256.png'
    },
    'Plutonium Fuel Rod': {
        image: 'Items/IconDesc_PlutoniumFuelRod_256.png'
    },
    'Heat Sink': {
        image: 'Items/IconDesc_Heatsink_256.png'
    },
    'Encased Plutonium Cell': {
        image: 'Items/IconDesc_EncasedPlutoniumCell_256.png'
    },
    'High-Speed Connector': {
        image: 'Items/IconDesc_HighSpeedConnector_256.png'
    },
    'Circuit Board': {
        image: 'Items/IconDesc_CircuitBoard_256.png'
    },
    'Computer': {
        image: 'Items/IconDesc_Computer_256.png'
    },
    'AI Limiter': {
        image: 'Items/IconDesc_AILimiter_256.png'
    },
    'Supercomputer': {
        image: 'Items/IconDesc_SuperComputer_256.png'
    },
    'Battery': {
        image: 'Items/IconDesc_Battery_256.png'
    },
    'Radio Control Unit': {
        image: 'Items/IconDesc_RadioControlUnit_256.png'
    },
    'Aluminum Casing': {
        image: 'Items/IconDesc_AluminiumCasing_256.png'
    },
    'Motor': {
        image: 'Items/IconDesc_Engine_256.png'
    },
    'Stator': {
        image: 'Items/IconDesc_Stator_256.png'
    },
    'Cooling System': {
        image: 'Items/IconDesc_CoolingSystem_256.png'
    },
    'Turbo Motor': {
        image: 'Items/IconDesc_TurboMotor_256.png'
    },
    'Pressure Conversion Cube': {
        image: 'Items/IconDesc_ConversionCube_256.png'
    },
    'Packaged Nitrogen Gas': {
        image: 'Items/IconDesc_PackagedNitrogen_256.png'
    },
    'Modular Engine': {
        image: 'Items/IconDesc_SpelevatorPart_4_256.png'
    },
    'Fused Modular Frame': {
        image: 'Items/IconDesc_FusedModularFrame_256.png'
    },
    'Thermal Propulsion Rocket': {
        image: 'Items/IconDesc_ThermalPropulsionRocket_256.png'
    },
    'Gas Filter': {
        image: 'Items/IconDesc_GasMaskFilter_256.png'
    },
    'Iodine Infused Filter': {
        image: 'Items/IconDesc_HazmatFilter_256.png'
    },
    'Versatile Framework': {
        image: 'Items/IconDesc_SpelevatorPart_2_256.png'
    },
    'Automated Wiring': {
        image: 'Items/SpelevatorPart_3_256.png'
    },
    'Adaptive Control Unit': {
        image: 'Items/IconDesc_SpelevatorPart_5_256.png'
    },
    'Magnetic Field Generator': {
        image: 'Items/IconDesc_MagneticFieldGenerator_256.png'
    },
    'Portable Miner': {
        image: 'Tools/PortableMiner_256.png'
    },
    'Iron Rebar': {
        image: 'Items/IconDesc_Rebar_256.png'
    },
    'Explosive Rebar': {
        image: 'Items/IconDesc_ExpRebar_256.png'
    },
    'Nobelisk': {
        image: 'Items/IconDesc_Explosive_256.png'
    },
    'Nuke Nobelisk': {
        image: 'Items/IconDesc_Nuke_256.png'
    },
    'Rifle Ammo': {
        image: 'Items/IconDesc_Rifle_256.png'
    },
    'Turbo Rifle Ammo': {
        image: 'Items/IconDesc_TurboRifle_256.png'
    },
    'Packaged Turbofuel': {
        image: 'Items/IconDesc_TurboFuel_256.png'
    },
    'Empty Canister': {
        image: 'Items/IconDesc_EmptyCannister_256.png'
    },
    'Empty Fluid Tank': {
        image: 'Items/IconDesc_PressureTank_256.png'
    },
    'Alien Protein': {
        image: 'Items/IconDesc_AlienProtein_256.png'
    },
    'Alien DNA Capsule': {
        image: 'Items/IconDesc_AlienDNA_256.png'
    },
    'Plasma Spitter Remains': {
        image: 'Items/IconDesc_AlienOrgans_256.png'
    },
    'Stinger Remains': {
        image: 'Items/IconDesc_AlienOrgans_256.png'
    },
    'Hatcher Remains': {
        image: 'Items/IconDesc_AlienOrgans_256.png'
    },
    'Hog Remains': {
        image: 'Items/IconDesc_AlienOrgans_256.png'
    },
    'Leaves': {
        image: 'Items/IconDesc_Leaves_256.png'
    },
    'Biomass': {
        image: 'Items/IconDesc_Biomass_Final_256.png'
    },
    'Wood': {
        image: 'Items/IconDesc_Wood_256.png'
    },
    'Flower Petals': {
        image: 'Items/FlowerPetals_Final_256.png'
    },
    'Color Cartridge': {
        image: 'Items/IconDesc_ColorCartridge_256.png'
    },
    'Copper Powder': {
        image: 'Items/IconDesc_CopperDust_256.png'
    },
    'Nitrogen Gas': {
        image: 'Items/IconDesc_PackagedNitrogen_256.png'
    },
    'Nitric Acid': {
        image: 'Items/IconDesc_NitricAcid_256.png'
    },
    'Petroleum Coke': {
        image: 'Items/IconDesc_PetroleumCoke_256.png'
    },
    'Uranium Waste': {
        image: 'Items/IconDesc_NuclearWaste_256.png'
    },
    'Non-fissile Uranium': {
        image: 'Items/IconDesc_NonFissileUranium_256.png'
    },
    'FICSIT Coupon': {
        image: 'Items/IconDesc_Ficsit_Coupon_256.png'
    },
    'Alclad Aluminum Sheet': {
        image: 'Items/IconDesc_AluminiumSheet_256.png'
    },
    'Power Shard': {
        image: 'Items/PowerShard_256.png'
    }
}